// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"Overlay-v7e2G","fadeOverlay":"fadeOverlay-1Ffg4"};